import React from "react";
import FormattedDate from "./FormattedDate";
import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1>{props.data.city}</h1>
      <ul className="weather-details">
        <li>
          <FormattedDate date={props.data.date} />
        </li>
        <li>{props.data.description}</li>
      </ul>
      <div className="row">
        <div className="col-sm-6 d-flex align-items-center">
          <img src={props.data.icon} alt={props.data.iconDescription} />
          <span className="temperature">
            {Math.round(props.data.temperature)}
          </span>
          <span className="unit ">°C</span>
        </div>
        <div className="col-sm-6 d-flex align-items-center mb-3">
          <ul className="weather-details">
            <li>Feels like: {Math.round(props.data.feelsLike)}°C</li>
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind: {Math.round(props.data.wind)} km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
